import { useEffect, useRef, useState } from "react";
import styles from "./OverlayCard.module.css";

export default function OverlayCard({
  title,
  description,
  image,
  imageLeft = true,
}) {
  const contentRef = useRef(null);
  const [imageHeight, setImageHeight] = useState("auto");

  useEffect(() => {
    const updateImageHeight = () => {
      // Only update for mobile and tablet (d-lg-none elements)
      if (contentRef.current && window.innerWidth < 992) {
        const contentHeight = contentRef.current.offsetHeight;
        setImageHeight(`${contentHeight}px`);
      } else {
        setImageHeight("auto");
      }
    };

    // Initial update
    const timer = setTimeout(updateImageHeight, 50);

    // Update on resize and content changes
    window.addEventListener("resize", updateImageHeight);

    // Observe content changes
    const resizeObserver = new ResizeObserver(updateImageHeight);
    if (contentRef.current) {
      resizeObserver.observe(contentRef.current);
    }

    // Cleanup
    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", updateImageHeight);
      resizeObserver.disconnect();
    };
  }, [description]);

  return (
    <>
      {/* Mobile & Tablet layout: Always image then content */}
      <div className="d-lg-none">
        <div className="col-12" style={{ height: imageHeight }}>
          <ImageWithOverlay title={title} image={image} height={imageHeight} />
        </div>
        <div ref={contentRef} className={`col-12 ${styles.contentBox}`}>
          {Array.isArray(description) ? (
            description.map((item, i) => (
              <p key={i} className={styles.text}>
                {item}
              </p>
            ))
          ) : (
            <p className={styles.text}>{description}</p>
          )}
        </div>
      </div>

      {/* Desktop layout: Original alternating design */}
      <div className="d-none d-lg-flex row g-0">
        {imageLeft && (
          <div className="col-lg-6">
            <ImageWithOverlay title={title} image={image} />
          </div>
        )}

        <div className={`col-lg-6 ${styles.contentBox}`}>
          {Array.isArray(description) ? (
            description.map((item, i) => (
              <p key={i} className={styles.text}>
                {item}
              </p>
            ))
          ) : (
            <p className={styles.text}>{description}</p>
          )}
        </div>

        {!imageLeft && (
          <div className="col-lg-6">
            <ImageWithOverlay title={title} image={image} />
          </div>
        )}
      </div>
    </>
  );
}

function ImageWithOverlay({ image, title, height }) {
  return (
    <div
      className={styles.imageCard}
      style={height !== undefined ? { height: height } : {}}
    >
      <img src={image} alt={title} className={styles.image} />
      <div className={styles.overlay}>
        <h5 className={styles.title}>{title}</h5>
      </div>
    </div>
  );
}
